import { render, staticRenderFns } from "./TeacherAdd.vue?vue&type=template&id=dbcc9636&scoped=true"
import script from "./TeacherAdd.vue?vue&type=script&lang=js"
export * from "./TeacherAdd.vue?vue&type=script&lang=js"
import style0 from "./TeacherAdd.vue?vue&type=style&index=0&id=dbcc9636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcc9636",
  null
  
)

export default component.exports